import React from "react";
import { Col, Row } from "react-bootstrap";
import { useFormContext, useWatch } from "react-hook-form";
import { APPOINTMENT_SKUS } from "../../helpers/constants";
import useProductsSelected from "../../hooks/useProductsSelected";
import { DatePicker } from "../fields/DatePicker";
import { InlineCheckbox } from "../fields/InlineCheckbox";

const timeFields = [
  { value: "No Preference", label: "No Preference" },
  { value: "AM", label: "AM" },
  { value: "PM", label: "PM" },
];

const AppointmentDateSelect = ({ group_name, show_skus, group_label }) => {
  const show = useProductsSelected(show_skus);
  const appointment_selected = useProductsSelected(APPOINTMENT_SKUS);

  const { setValue } = useFormContext();

  const radio_name = `order_info.${group_name}_date_type`;
  const date_name = `order_info.${group_name}_date`;
  const time_name = `order_info.${group_name}_time`;
  const dateValue = useWatch({ name: radio_name });

  const dateFields = [
    { value: "asap", label: "ASAP" },
    { value: "date", label: "Request A Date" },
  ];

  if (group_name === "sign" && appointment_selected) {
    dateFields.splice(1, 0, {
      value: "With other services",
      label: `At the same time as my other appointments`,
    });
  }

  if (!show) return null;

  return (
    <>
      <p className="font-weight-bold">{`When would you like us to come by ${group_label}?*`}</p>
      <div className="mb-5">
        {dateFields.map(({ value, label }) => (
          <InlineCheckbox
            type="radio"
            key={group_name + value}
            sku={radio_name}
            value={value}
            label={label}
            controlId={group_name + value}
            onChange={(e, val) => {
              // if (val === "asap") {
              // }
              setValue(date_name, val !== "date" ? val : undefined);
            }}
            required
          />
        ))}
        {dateValue === "date" && (
          <Row>
            <Col sm={8} md={6} lg={4}>
              <DatePicker
                name={date_name}
                type="date"
                subText="Requested date subject to availability."
                required
              />
            </Col>
          </Row>
        )}
      </div>
      {group_name !== "sign" && (
        <div className="mb-5">
          <p className="font-weight-bold">What Time of day do you prefer?*</p>
          {timeFields.map(({ value, label }) => (
            <InlineCheckbox
              type="radio"
              key={group_name + value}
              name={time_name}
              value={value}
              label={label}
              controlId={group_name + value}
              required
            />
          ))}
        </div>
      )}
    </>
  );
};

export default AppointmentDateSelect;
